import { scrollTo } from "@bitcart/core/navigation";
// src/lifecycle/page-transition-end.ts
const createOnPageTransitionEnd = () => {
	return function onPageTransitionEnd(pageContext) {
		const hash = pageContext.urlParsed.hash;
		window.setTimeout(() => {
			if (hash) scrollTo({ selector: `#${hash}` });
			else scrollTo({ direction: "top" });
		}, 0);
	};
};
export { createOnPageTransitionEnd };

//# sourceMappingURL=page-transition-end.js.map